import React, { createContext, useContext, useState } from 'react';

const HideNavContext = createContext(null);

export function HideNavProvider({ children }) {
  const [hideNav, setHideNav] = useState(false);
  return (
    <HideNavContext.Provider value={{ hideNav, setHideNav }}>
      {children}
    </HideNavContext.Provider>
  );
}

export function useHideNav() {
  const ctx = useContext(HideNavContext);
  return ctx || { hideNav: false, setHideNav: () => {} };
}
